import './home.css';
import { conCategorias } from '../../conexiones/varConexiones.js';
import { useSelector } from 'react-redux';
import React, {useEffect, useState } from 'react';
import { Suspense } from 'react';
import {fetchData} from '../../fetch/fetchData.js';
import Bloque from '../../componentes/bloque_queHago/Bloque.js';
import Slide from '../../componentes/slide/Slide';
import Seccion from '../../componentes/seccion/Seccion';
import Modal from '../../componentes/modal/Modal';
import Bannercaso from '../../componentes/BannerCaso/Banner_caso.js';
import casos from '../../componentes/Caso/casos.js';
import homewords from './homeDictionary.js';

const apiData = fetchData(conCategorias);

const Home = (props) => {
  const lang = useSelector((state) => state.lang.lang);
  const dataCasos = casos;
  const data = apiData.read();
  const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null,scroll:true});

  function scrollingWindows (){
    if(estadoModal.scroll === true){
      return window.scrollY > 0 ? window.scroll({top: 0,behavior: "smooth"}):null;
    }
  }
  useEffect(()=>{
    scrollingWindows()
  })
  return (
    <>
      <Modal estado={estadoModal} cambiarEstado={cambiaEstadoModal}></Modal>
      <><Slide /></>
      <>
        <Suspense fallback={<div>Cargando...</div>}>
          <div className='central'>
          <Bloque />
          <div className='central-trabajos' style={{width:'100%', boxSizing:'border-box'}} ref={props.mainref}>
            {/* casos */}
            <div className='central-casos'>
              {/* <h3 className='central-casos-titulo'>{Object.values(homewords.titulo[lang])}</h3> */}
                {Object.values(dataCasos).map((caso) => {
                  return caso.state === 'ok'? <Bannercaso key={caso.id} id={caso.id} thum={caso.thum} textos={caso[lang]} />:''
                })}
            </div>
            {data?.listacategorias.map(
              (cat)=>(
                
                  <Seccion key={cat.id_cat} categoria={cat.nombre_categoria} catId={cat.id_cat} action={cambiaEstadoModal}></Seccion>
              ))
            }
            </div>
          </div>
        </Suspense>
      </>
      </>
  );
}

export default Home;
